import { Component, EventEmitter, Input, Output } from '@angular/core'

import { ApplicationSetting } from '@app/core/model/enums/application-setting.enum'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { DeliverableSection } from '@app/features/scope-overview/model/deliverable-section'
import { MenuOptions } from '@app/core/model/definitions/menu-options.interface'
import { Privilege } from '@app/core/model/enums/privilege.enum'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ScopeElementsService } from '../services/scope-elements.service'
import { UpdateFeeItemPayload, UpdateRolePayload, UpdateTpcPayload, ScopeElementsConfig } from '../models'
import { User } from '@app/core/model/user.model'
import { getThirdPartyCostColumns } from '../utils'
import { ThirdPartyCost } from '@app/core/model/third-party-cost.model'
import { isPreferenceActive } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'
import { UpdateComponentPayload } from '../models/update-component-payload.interface'
import { DEFAULT_PLACEHOLDER } from '@app/shared/constants/default-placeholder.const'

@Component({ selector: 'scope-deliverable-sections-row', templateUrl: './deliverable-sections-row.component.html' })
export class DeliverableSectionsRowComponent {
  @Input() section: DeliverableSection
  @Input() components: ScopeComponent[]
  @Input() deliverable: Deliverable
  @Input() componentMenuOptions: MenuOptions[]
  @Input() feeMenuOptions: MenuOptions[]
  @Input() currentUser: User
  @Input() config: ScopeElementsConfig
  @Input() level: number

  @Output() onUpdateComponent = new EventEmitter<UpdateComponentPayload>()
  @Output() onOverrideComponentQuantity = new EventEmitter<ScopeComponent>()
  @Output() onOverrideRateCardRoleHours = new EventEmitter<UpdateRolePayload>()
  @Output() onMoveComponent = new EventEmitter<{ component: ScopeComponent; deliverable: Deliverable }>()
  @Output() onMoveComponentOutsideDeliverable = new EventEmitter<ScopeComponent>()
  @Output() onUpdateComponentTpc = new EventEmitter<UpdateTpcPayload>()
  @Output() onReorderComponentTpcs = new EventEmitter<any>()
  @Output() onUpdateDeliverableSectionTpc = new EventEmitter<UpdateTpcPayload>()
  @Output() onReorderDeliverableSectionTpcs = new EventEmitter<any>()
  @Output() onUpdateFeeItem = new EventEmitter<UpdateFeeItemPayload>()
  @Output() onUpdateRole = new EventEmitter<UpdateRolePayload>()

  constructor(protected scopeElementsService: ScopeElementsService) {}

  selectSection(sectionId: number) {
    this.scopeElementsService.toggleDeliverableSection(sectionId)
  }

  getTpcColumns = () =>
    getThirdPartyCostColumns(this.config?.isEditable, (thirdPartyCost: ThirdPartyCost) =>
      this.onUpdateDeliverableSectionTpc.emit({ deliverable: this.deliverable, section: this.section, thirdPartyCost })
    )

  updateDeliverableSectionTpc(thirdPartyCost: ThirdPartyCost) {
    this.onUpdateDeliverableSectionTpc.emit({ deliverable: this.deliverable, section: this.section, thirdPartyCost })
  }

  reorderDeliverableSectionTpcs(thirdPartyCosts: ThirdPartyCost[]) {
    this.onReorderDeliverableSectionTpcs.emit({
      deliverable: this.deliverable,
      section: this.section,
      thirdPartyCosts,
    })
  }

  protected readonly Privilege = Privilege
  protected readonly ApplicationSetting = ApplicationSetting
  protected readonly isPreferenceActive = isPreferenceActive
  protected readonly DEFAULT_PLACEHOLDER = DEFAULT_PLACEHOLDER
}
